import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useParams } from 'react-router-dom';
import { AppDashboardView } from './view';
import { APP_VALIDATION_REPORT_QUERY } from 'const/queries';
import { APP_SUBMIT_FOR_REVIEW, APP_CUSTOM_LINK_TO_VENDOR } from 'const/mutations';
import { useAppQuery, useAppTestUninstall } from '../../../types/generated';

export function AppDashboard() {
    const { id: appId } = useParams<{ id: string }>();

    const queryVars = { id: appId };
    const { loading, data, refetch: refetchApp } = useAppQuery({ variables: queryVars });
    const selectedApp = data && data.app;

    const {
        loading: validationReportLoading,
        error: validationReportError,
        data: validationReportData,
        refetch,
    } = useQuery(APP_VALIDATION_REPORT_QUERY, {
        variables: queryVars,
        fetchPolicy: 'network-only',
    });

    const [appSubmitForReview, { loading: appSubmittingForReview }] =
        useMutation(APP_SUBMIT_FOR_REVIEW);
    const onSubmitAppForReview = async () => {
        await appSubmitForReview({ variables: queryVars });
        refetch(queryVars);
    };

    const [linkToVendor, { loading: linkToVendorLoading }] = useMutation(APP_CUSTOM_LINK_TO_VENDOR);
    const handleLinkToVendor = vendor =>
        linkToVendor({ variables: { appId: appId, vendorId: vendor.id } });

    const [testUninstall, { loading: testUninstallLoading }] = useAppTestUninstall({
        variables: queryVars,
    });
    const onTestUninstall = () => testUninstall({ variables: queryVars });

    return (
        <AppDashboardView
            refetch={() => refetchApp()}
            app={selectedApp}
            loading={loading}
            validationReport={validationReportData && validationReportData.appValidationReport}
            validationReportLoading={validationReportLoading}
            validationReportError={validationReportError}
            onSubmitAppForReview={onSubmitAppForReview}
            appSubmittingForReview={appSubmittingForReview}
            onLinkToVendor={handleLinkToVendor}
            linkToVendorLoading={linkToVendorLoading}
            onTestUninstall={onTestUninstall}
            testUninstallLoading={testUninstallLoading}
        />
    );
}
